import Api from "../../axios";

export default async function apiUserFeedbackList() {
  return await Api.get("/user_list_feedback");
}
